<ion-button
  strong
  mode="md"
  shape="round"
  [disabled]="disabled"
  (click)="buttonClick.emit($event)"
  [class.is-instance-color]="isInstanceColor"
>
  <ng-content></ng-content>
</ion-button>
